import { StatsContent } from './StatsContent';

export function StatsModal({
  onClose,
  storageNamespace,
  strings,
  refreshKey,
  isHardcore = false,
}: {
  onClose: () => void;
  storageNamespace?: string;
  strings: {
    title: string;
    closeLabel: string;
    gamesLabelPlural: string;
    gamesLabelSingular: string;
    winRateLabel: string;
    currentStreakLabel: string;
    bestStreakLabel: string;
    performanceTitle: string;
    lossLabel: string;
    timeTitle: string;
    bestTimeLabel: string;
    avgTimeLabel: string;
    worstTimeLabel: string;
  };
  refreshKey?: number;
  isHardcore?: boolean;
}) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center px-3 sm:px-0">
      <div className="absolute inset-0 bg-black/60" onClick={onClose} />

      <div
        className={`
          relative w-full max-w-lg
          rounded-xl bg-neutral-900 text-white
          p-4 sm:p-6
          ${isHardcore ? 'ring-1 ring-red-500/30' : ''}
        `}
      >
        <h2 className="mb-5 flex items-center gap-2 text-lg sm:text-xl font-semibold">
          {strings.title}
          {isHardcore && (
            <span className="rounded-full bg-red-600/20 px-2 py-0.5 text-xs font-bold uppercase tracking-wider text-red-400">
              Hardcore
            </span>
          )}
        </h2>

        <StatsContent
          isPerfectWin={false}
          isHardcore={isHardcore}
          storageNamespace={storageNamespace}
          strings={strings}
          refreshKey={refreshKey}
        />

        <button
          onClick={onClose}
          className="
            mt-5 w-full rounded-md
            bg-neutral-700 py-2
            text-sm sm:text-base
            font-bold hover:bg-neutral-600
          "
        >
          {strings.closeLabel}
        </button>
      </div>
    </div>
  );
}
